import { render, staticRenderFns } from "./PageModeratorEventEventInstitutionGroupEventInstitutionGroupMemberDelete.vue?vue&type=template&id=3283bce6&"
import script from "./PageModeratorEventEventInstitutionGroupEventInstitutionGroupMemberDelete.vue?vue&type=script&lang=js&"
export * from "./PageModeratorEventEventInstitutionGroupEventInstitutionGroupMemberDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VContainer})
